<template>
<!-- 图片的列表 -->
<div class="page imgSess">
    <!-- 列表 -->
    <div class="img-outbox">
      
        <div class="img-item" v-for="(item, index) in epeciaList" :key="index">
            <div class="sessimg-left">
                <a :href="'javascript:;'" v-if="$route.query.from == 1">
                    <div class="imgBox">
                        <el-image style="width: 100%; height: 100%;object-fit: cover" :src="item.FileName" fit="contain">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                            <div slot="error" class="el-image__error">
                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                            </div>
                        </el-image>
                        <div v-if="item.IsBigPic==1" class="iconSess">超清</div>
                    </div>
                </a>
                <a :href="'/paimai-'+item.ArtCode+'?from=2'" v-else-if="$route.query.from == 2">
                    <div class="imgBox">
                        <el-image style="width: 100%; height: 100%;object-fit: cover" :src="item.FileName" fit="contain">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                            <div slot="error" class="el-image__error">
                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                            </div>
                        </el-image>
                        <div v-if="item.IsBigPic==1" class="iconSess">超清</div>
                    </div>
                </a>
                <a :href="'/paimai-'+item.ArtCode" v-else>
                    <div class="imgBox">
                        <el-image style="width: 100%; height: 100%;object-fit: cover" :src="item.FileName" fit="contain">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                            <div slot="error" class="el-image__error">
                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                            </div>
                        </el-image>
                        <!-- <img v-if="item.IsBigPic!=1" class="iconSess" src="@/assets/previewImg/icon_list_HDpic_26@2x.png" alt="" /> -->
                        <div v-if="item.IsBigPic==1" class="iconSess">超清</div>
                    </div>
                </a>
            </div>
            <div class="sessimg-right">
                <div class="sessimg-title">
                    <a :href="'javascript:;'" v-if="$route.query.from == 1">
                        <img style="margin-right: 2px;" src="@/assets/imgs/Group6@2x.png">{{ item.TlNumber }}<img style="margin-left: 2px;" src="@/assets/imgs/Group5@2x.png"> {{nameDelBr(item.WorkName)}}
                    </a>
                    <a :href="'/paimai-'+item.ArtCode+'?from=2'" v-else-if="$route.query.from == 2">
                        <img style="margin-right: 2px;" src="@/assets/imgs/Group6@2x.png">{{ item.TlNumber }}<img style="margin-left: 2px;" src="@/assets/imgs/Group5@2x.png"> {{nameDelBr(item.WorkName)}}
                    </a>
                    <a :href="'/paimai-'+item.ArtCode" target="_blank" v-else>
                        <img style="margin-right: 2px;" src="@/assets/imgs/Group6@2x.png">{{ item.TlNumber }}<img style="margin-left: 2px;" src="@/assets/imgs/Group5@2x.png"> {{nameDelBr(item.WorkName)}}
                    </a>
                </div>
                <div >
                    <div class="sessimg-sum">
                        <!-- <div class="sum-item">
                            <span class="tit">Lot号：</span>
                            <span class="cont">{{ item.TlNumber }}</span>
                        </div> -->
                        <div style="margin-bottom: 6px;">
                            <div v-if="item.BidStatus==1" class="bidStatus1">待拍卖</div>
                            <div v-if="item.BidStatus==2||item.BidStatus==4" class="bidStatus2">
                                <lottie :options="heartOptions2" :height="10" :width="10" :style="'display: inline-block;margin-right:5px'" />拍卖中</div>
                            <div v-if="item.BidStatus==3||item.BidStatus==5" class="bidStatus3">已结拍</div>
                        </div>
                        <div class="sum-item">
                            <span class="tit">{{item.Price.label}}</span>
                            <!-- <template v-for="(con,k) in item.Price">
                                <span class="tit" :key="k" v-if="con.type == 'gujia'">估价：</span>
                                <span class="tit" :key="k" v-if="con.type == 'start_price'">起始价：</span>
                                <span class="tit" :key="k" v-if="con.type == 'now_price'">当前价：</span>
                                <span class="tit" :key="k" v-if="con.type == 'price'">成交价：</span>
                            </template> -->

                            <span class="cont sessimg-red" v-if="pmstatus !=5">
                                <strong class="price">{{item.Price.text!='撤拍'&&item.Price.text!='流拍'&&item.Price.text!='未提供'?item.Price.smallText:''}} {{item.Price.text}}</strong>
                                <!-- <template v-for="(con,k) in item.pc_extra_info">
                                    <strong class="price" :key="k" v-if="con.type == 'gujia'">{{con.text!='撤拍'&&con.text!='流拍'&&con.text!='未提供'?con.smallText:''}} {{con.text}}</strong>
                                    <strong class="price" :key="k" v-if="con.type == 'start_price'">{{con.text!='撤拍'&&con.text!='流拍'&&con.text!='未提供'?con.smallText:''}} {{con.text}}</strong>
                                    <strong class="price" :key="k" v-if="con.type == 'now_price'">{{con.text!='撤拍'&&con.text!='流拍'&&con.text!='未提供'?con.smallText:''}} {{con.text}}</strong>
                                    <strong class="price" :key="k" v-if="con.type == 'price'">{{con.text!='撤拍'&&con.text!='流拍'&&con.text!='未提供'?con.smallText:''}} {{con.text}}</strong>
                                    
                                </template> -->
                                <!-- <template v-if="item.EvaluationType == 1">无底价</template>
                                <template v-else-if="item.EvaluationType == 2">咨询价</template>
                                <template v-else-if="item.EvaluationType == 3">估价待定</template>
                                <template v-else>
                                    <template v-if="item.OriginalEvaluation == 0 && item.LastEvaluation == 0">--</template>
                                    <template v-else-if="item.OriginalEvaluation == item.LastEvaluation">{{ item.OriginalEvaluation }}</template>
                                    <template v-else>{{item.CurrencyType}} {{ formatPrice(item.OriginalEvaluation) }}-{{
                                            formatPrice(item.LastEvaluation)
                                        }}</template>
                                </template> -->
                            </span>
                            <span class="cont " v-else>
                                        <div>
                                            <strong class="price" v-if="isLogin > 0&&isMem==1">
                                                <template v-if="item.Price.text!='未提供'">
                                                    {{item.Price.smallText}} {{item.Price.text}}
                                                </template>
                                                <template v-else>
                                                    {{item.Price.text}}
                                                </template>
                                            </strong>
                                            <strong v-else-if="item.Price.text=='未提供'"><a href="javascript:;" @click="gotoLogin" class="item-red">{{item.Price.text}}</a></strong>
                                            <strong v-else><a href="javascript:;" @click="gotoLogin" class="item-red">{{item.Price.smallText}}&nbsp;{{item.Price.nonMemberText}}</a></strong>
                                        </div>

                                    
                                    <!-- <strong class="price" :key="k" v-if="con.type == 'price' && ifLogin > 0&&isMem==1">{{con.smallText}} {{con.text}}</strong>
                             <strong :key="k" v-if="con.type == 'price' && !ifLogin > 0&&isMem!=1"><a  href="javascript:;" @click="gotoLogin" class="item-red">{{con.smallText}}&nbsp;{{con.nonMemberText}}</a></strong> -->
                        
                                <!-- <template v-if="isLogin"><i class="sessimg-red">
                                        <template v-if="item.CurrencyPrice == 0">
                                            <template v-if="item.Status == 1">撤拍</template>
                                            <template v-else-if="item.Status == 2">流拍</template>
                                            <template v-else>未提供</template>
                                        </template>
                                        <template v-else>{{item.CurrencyType}} {{formatPrice(item.CurrencyPrice)}}</template>
                                        </i></template>
                                    <template v-else><a href="javascript:;" @click="gotoLogin">请登录后查看</a></template> -->
                                <!-- <template v-if="isLogin"><i class="sessimg-red">
                                        <template v-if="item.CurrencyPrice == 0&&isMem==1">
                                            <template v-if="item.Status == 1">撤拍</template>
                                            <template v-else-if="item.Status == 2">流拍</template>
                                            <template v-else>未提供</template>
                                        </template>
                                        <template v-else-if="isMem!=1">
                                            <template v-if="item.Status == 1">{{item.CurrencyType}}****</template>
                                            <template v-else-if="item.Status == 2">{{item.CurrencyType}}****</template>
                                            <template v-else-if="item.Status == 3||item.CurrencyPrice==0&&item.Status == 0">未提供</template>
                                            <template v-else>{{item.CurrencyType}}&nbsp;{{formatPriceTologin(item.CurrencyPrice)}}</template>
                                        </template>
                                        <template v-else>
                                            <template v-if="item.Status != 3&&item.CurrencyPrice != 0">
                                                {{item.CurrencyType}}&nbsp;{{formatPrice(item.CurrencyPrice)}}
                                            </template>
                                            <template v-else>
                                                未提供
                                            </template>

                                        </template>
                                    </i></template>
                                <template v-else><a href="javascript:;" @click="gotoLogin" class="sessimg-red">
                                        <template v-if="item.Status == 1 || item.Status == 2">{{item.CurrencyType}}****</template>
                                        <template v-else-if="item.Status != 3&&item.CurrencyPrice != 0">
                                            {{item.CurrencyType}}&nbsp;{{formatPriceTologin(item.CurrencyPrice)}}
                                        </template>
                                        <template v-else>
                                            未提供
                                        </template>

                                    </a></template> -->
                            </span>
                        </div>
                        <!-- <div class="sum-item">
                            <span class="tit">城市：</span>
                            <span class="cont">{{ city }}</span>
                        </div> -->
                        <div class="sum-item">
                            <span class="tit">拍卖时间：</span>
                            <span class="cont">
                                    <strong  >{{item.Date}}</strong>
                              
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 分页 -->
    <div class="paging">
        <el-pagination background :page-size="48" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout=" prev, pager, next" :current-page.sync="jumpVal" :total="num ? num : 0" :prev-text="'&lt; 上一页'" :next-text="'下一页 &gt;'">
        </el-pagination>
        <span class="total"><i>{{ currentPage }}</i>/{{ num ? Math.ceil(num / 48) : 0 }}</span>
        <div class="jumpBox">
            跳至
            <input type="text" class="inputJump" v-model="jumpVal" @input="changeNum" />
            页
        </div>
    </div>
</div>
</template>

<script>
import {
    getMemType
} from "@/api/auction";
import lottie from '@/components/common/lottie'
const liveIcon2 = require('@/assets/imgs/live.json')
export default {
    props: ["pageId", "status", 'num', 'epeciaList', 'city'],
    components: {
        lottie,
    },
    computed: {
        pmstatus() {
            return this.status
        }
    },
    data() {
        return {
            heartOptions2: {
                animationData: liveIcon2,
                loop: true,
                autoplay: true,
            },
            arrList: [{
                    name: "Lot号：",
                    content: "0011",
                    type: 0
                },
                {
                    name: "估价：",
                    content: "GBP 8,000-11,000",
                    type: 1
                },
                {
                    name: "城市：",
                    content: "石家庄",
                    type: 0
                },
                {
                    name: "日期：",
                    content: "2021-03-31",
                    type: 0
                },
            ],
            jumpVal: null,
            currentPage: null, //当前页面
            isLogin: 0,
            isMem: 0,
            t: 0
        };
    },
    mounted() {
        this.t = Date.now()
        this.jumpVal = this.pageId;
        this.currentPage = this.pageId;
        if (this.getCookie("_at_pt_0_")) {
            this.isLogin = 1
        }
        this.getMemType()

    },
    methods: {
        formatPriceTologin(num) {
            // if (num == 0) {
            //     return "****"
            // }
            // let str = (num + '').substring(0, 1);
            // return str + '***';
            return "****"
        },
        nameDelBr(str) {

            return str.replace('<br>','')
        },

        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                }
            })
        },
        changeNum() {
            this.jumpVal =
                Number(this.jumpVal) < 0 || !Number(this.jumpVal) ?
                0 :
                this.jumpVal;

            this.jumpVal =
                // 判断不能超过总页码  超过则显示最大值
                this.jumpVal > Math.ceil(this.num / 48) ?
                Math.ceil(this.num / 48) :
                this.jumpVal;
            console.log(typeof this.jumpVal);
            this.currentPage = Number(this.jumpVal);
            this.$emit("pagelimt", this.currentPage);
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = Number(val);
            this.$emit("pagelimt", this.currentPage);
        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        gotoLogin() {
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        },
        formatPrice(num) {
            var arr = (num + '').split('.');
            var intSum = arr[0].replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分
            var fen = arr[1] ? '.' + arr[1] : ''
            var ret = intSum + fen;
            return ret;
        }
    },
};
</script>

<style lang="scss">
.imgSess {
    width: 1180px;
    margin: auto;
}
.imgBox{
    background-color: #fff !important;
}
// 图文列表样式
.img-outbox {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .img-item {
        width: 275px;
        margin: 40px 24px 0 0;
        // background-color: lightblue;
        display: flex;

        flex-direction: column;
        border-radius: 4px;

        &:nth-child(4n) {
            margin-right: 0;
        }

        .sessimg-left {
            width: 100%;
            height: 275px;
            position: relative;
            overflow: hidden;
            border-radius: 4px 0 0 4px;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }

            .iconSess {
                width: 38px;
                height: 20px;
                background: rgba(0, 0, 0, 0.20);
                color: #fff;
                padding: 1px 7px;
                position: absolute;
                border-radius: 35px;
                font-size: 12px;
                font-weight: 500;
                top: 10px;
                right: 10px;
            }
        }

        .sessimg-right {
            // margin: 20px;
            width: 100%;
            border-radius: 0px 4px 4px 0px;
            box-sizing: border-box;

            .sessimg-title {
                font-size: 16px;
                font-weight: 600;
                font-family: MicrosoftYaHei;
                color: #262626;
                padding: 20px 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                img {
                    width: 6px;
                    height: 16px;
                    vertical-align: middle;
                }
            }

            .sessimg-sum {

                .bidStatus1 {
                    background: rgba(50, 157, 21, 0.04);
                    border-radius: 3px 3px 3px 3px;
                    font-size: 10px;
                    padding: 4px 5px;
                    color: #329D15;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    display: inline-block;

                }

                .bidStatus2 {
                    background: rgba(246, 52, 75, 0.04);
                    border-radius: 3px 3px 3px 3px;
                    font-size: 10px;
                    padding: 4px 5px;
                    color: #F6344B;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    display: inline-block;
                }

                .bidStatus3 {
                    background: rgba(153, 153, 153, 0.08);
                    border-radius: 3px 3px 3px 3px;
                    font-size: 10px;
                    padding: 4px 5px;
                    color: #999999;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    display: inline-block;
                }

                // margin: 20px 0px;
                .sum-item {
                    display: flex;
                    justify-content: flex-start;

                    span {
                        display: inline-block;
                        margin-bottom: 5px;
                    }

                    .tit {
                        width: 70px;
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: #8c8c8c;

                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .cont {
                        width: calc(100% - 70px);
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: #8C8C8C;
                    }

                    .sessimg-red {
                        color: #000;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}

// 分页样式
.paging {
    width: 1180px;
    margin: 40px auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-pagination {
        display: inline-block;
        text-align: center;

        button {
            padding: 0 10px !important;
            line-height: 28px;
            border: 1px solid #bfbfbf;
            border-radius: 4px;
            background-color: transparent !important;
            color: #262626;
        }

        .el-pager {
            font-size: 0;

            li {
                padding: 0 10px;
                line-height: 28px;
                border: 1px solid #bfbfbf;
                border-radius: 4px;
                background-color: transparent;
                transition: 0.2s all ease-in-out;
                font-weight: normal;
            }

            li:hover,
            .active,
            .el-pagination.is-background .el-pager li:not(.disabled).active {
                border-color: #329d15;
                background-color: #eaf5e7;
                color: #329d15;
            }

            .more {
                border: 0;
            }
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        border-color: #329d15;
        background-color: #eaf5e7;
        color: #329d15;
    }

    .total {
        font-size: 14px;
        color: #595959;
        margin: 0 20px 0 15px;

        i {
            color: #329d15;
        }
    }

    .jumpBox {
        display: inline-block;
        line-height: 30px;
        color: #595959;
        font-size: 14px;

        .inputJump {
            width: 28px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid #bfbfbf;
            text-align: center;
            color: #595959;
            margin: 0 2px;
        }
    }
}
</style>
